export default "__VITE_ASSET__0d24cad0__"